import axios from 'axios';

class CheckoutApi {
  constructor() {
    this.cancelCheckEmail = false;
    this.cancelUpdateCart = () => {
    };
    this.cancelCalculateTaxes = () => {
    };
    this.cancelGetShipping = () => {
    };
    this.cancelGetCart = () => {}
  }

  removeProductRow(rowId) {
    return axios.delete(`/api/v1/cart/items/${rowId}`);
  }

  getCart() {
    this.cancelGetCart();
    const cancelToken = new axios.CancelToken(c => this.cancelGetCart = c);
    return axios.get('/api/v1/cart', {cancelToken});
  }

  updateCart(requestData) {
    this.cancelUpdateCart();
    const cancelToken = new axios.CancelToken(c => this.cancelUpdateCart = c);

    return axios.put(`/api/v1/cart/update`, requestData, {cancelToken});
  }

  getShipping(params) {
    this.cancelGetShipping();
    const cancelToken = new axios.CancelToken(c => this.cancelGetShipping = c);

    return axios.get('/api/v1/shipping', {params, cancelToken});
  }

  setShippingMethod({price, service_code, package_code, method_preview, original_price}) {
    return axios
      .post('/api/v1/cart/shipping', {
        price,
        service_code,
        package_code,
        method_preview,
        original_price,
      })
  }

  calculateTaxes(shipping) {
    this.cancelCalculateTaxes();
    const cancelToken = new axios.CancelToken(c => this.cancelCalculateTaxes = c);

    return axios.post('/api/v1/cart/taxes', shipping, {cancelToken});
  }

  checkEmail(email) {
    return axios.post('/api/v1/customer/checkEmail', {email});
  }

  login(email, password) {
    return axios.post('/login', {email, password});
  }

  async submitPayment(formData) {
    if (this.isCheckoutRecaptchaRequired() && null === formData['c_token']) {
      formData['c_token'] = await this.getRecaptchaToken();
    }

    return axios.post('/api/v1/checkout/process', formData).finally(() => {
      if (this.isCheckoutRecaptchaRequired() && null === formData['c_token']) {
        this.resetRecaptcha()
      }
    });
  }

  applyCoupon(coupon) {
    return axios.post(`/api/v1/cart/coupon/apply`, {coupon});
  }

  removeCoupon(coupon_id) {
    return axios.post(`/api/v1/cart/coupon/reset`, {coupon_id});
  }

  applyRewardPoints(points) {
    return axios.post(`/api/v1/cart/points/apply`, {points});
  }

  resetRewardPoints() {
    return axios.post(`/api/v1/cart/points/reset`);
  }

  toggleShippingForPoints(is_shipped_for_points) {
    return axios.post(`/api/v1/cart/points/shipping/toggle`, {is_shipped_for_points});
  }

  getGroupMessages() {
    return axios.get('/api/v1/customer/groups/messages');
  }

  validateAuthorizeNetApplePay(validation_url) {
    return axios.post('/api/v1/checkout/apple-pay/validate', {validation_url})
  }

  handlePaymentResponse(response) {
    const {status, message} = response.data;
    if (status === 'success') {
      if (response.data.redirect_url) {
        window.location.href = response.data.redirect_url;
      } else {
        window.location.href = '/account/';
      }
    }

    return {
      status,
      message,
    }
  }

  isCheckoutRecaptchaRequired() {
    return 1 === window.isCheckoutRecaptchaEnabled;
  }

  resetRecaptcha() {
    if (this.recaptchaReady() && this.hasPageRecaptchaContainer()) {
      window.grecaptcha.reset()
    }
  }

  async getRecaptchaToken() {
    if (this.recaptchaReady()) {
      const gaPromise = new Promise((res) => {
        return window.grecaptcha.ready(() => {
          return window.grecaptcha
            .execute(window.reCaptchaKey, {action: 'checkout_form'})
            .then((token) => {
              return res(token);
            });
        })
      });

      return await gaPromise.then(token => token);
    } else {
      return null;
    }
  }

  recaptchaReady() {
    return !!(window.reCaptchaKey && typeof window.grecaptcha !== 'undefined' && window.grecaptcha.render !== 'undefined');
  }
  hasPageRecaptchaContainer() {
    return document.querySelector('#recaptcha-container') || document.querySelector('.recaptcha-container')
  }
}

export default new CheckoutApi();
